import templateUrl from "emun.invoice/inv/inv-details-header.htm";

export default () => ({ templateUrl });
